<template>
  <a
    :href="`https://www.facebook.com/sharer/sharer.php?u=${fixedEncodeURIComponent(
      shareUrl.toString()
    )}${facebook_append}`"
    target="_blank"
    rel="noopener noreferrer"
  >
    <slot>
      <!-- Default slot content -->
      <BaseSocialShareButton>
        <SvgFacebook />
      </BaseSocialShareButton>
    </slot>
  </a>
</template>

<script setup lang="ts">
defineProps<{
  shareUrl: URL;
}>();

const facebook_append = "&amp;src=sdkpreparse"
</script>

<style lang="scss" scoped></style>
